import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d271bed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "uf-stores" }
const _hoisted_2 = { class: "uf-stores__body" }
const _hoisted_3 = { action: "/" }
const _hoisted_4 = { class: "uf-stores__info" }
const _hoisted_5 = { class: "uf-stores__item-name" }
const _hoisted_6 = { class: "uf-stores__item-label van-ellipsis" }
const _hoisted_7 = {
  key: 1,
  style: {"color":"#fff"}
}
const _hoisted_8 = { class: "popover-inner" }
const _hoisted_9 = { class: "uf-button" }
const _hoisted_10 = { class: "uf-button--footer" }
const _hoisted_11 = { class: "uf-stores__body" }
const _hoisted_12 = { class: "uf-stores__info" }
const _hoisted_13 = { class: "uf-stores__item-name" }
const _hoisted_14 = { class: "uf-stores__item-label van-ellipsis" }
const _hoisted_15 = {
  key: 1,
  style: {"color":"#fff"}
}
const _hoisted_16 = { class: "popover-inner" }
const _hoisted_17 = { class: "uf-button" }
const _hoisted_18 = { class: "uf-button--footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_popover = _resolveComponent("van-popover")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_checkbox_group = _resolveComponent("van-checkbox-group")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_popup, {
      show: _ctx.popupShow,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.popupShow) = $event)),
      position: "right",
      style: { height: '100%', width: '100%' },
      onOpened: _ctx.opened1
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_van_nav_bar, {
            title: "选择客户机构",
            "left-text": "返回",
            "left-arrow": "",
            onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.popupShow = false))
          }),
          _createElementVNode("form", _hoisted_3, [
            _createVNode(_component_van_search, {
              clearable: false,
              modelValue: _ctx.state.searchValue,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.searchValue) = $event)),
              shape: "round",
              placeholder: "搜索",
              onSearch: _ctx.onSearch
            }, null, 8, ["modelValue", "onSearch"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_van_checkbox_group, {
              modelValue: _ctx.checked,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.checked) = $event)),
              ref: "checkboxGroup"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_cell_group, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.list, (item, index) => {
                      return (_openBlock(), _createBlock(_component_van_cell, {
                        class: _normalizeClass({ active: _ctx.checked.includes(item) }),
                        clickable: "",
                        key: item.id,
                        center: "",
                        onClick: ($event: any) => (_ctx.toggle(index))
                      }, _createSlots({
                        icon: _withCtx(() => [
                          _withDirectives(_createVNode(_component_van_checkbox, {
                            style: {"margin-right":"10px"},
                            name: item,
                            ref_for: true,
                            ref: el => (_ctx.checkboxRefs[index] = el),
                            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                          }, null, 8, ["name"]), [
                            [_vShow, _ctx.multiple]
                          ])
                        ]),
                        title: _withCtx(() => [
                          _createElementVNode("div", _hoisted_5, _toDisplayString(item.stores_name), 1)
                        ]),
                        label: _withCtx(() => [
                          _createElementVNode("div", _hoisted_6, [
                            (item.place_true_names)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(item.place_true_names), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock("i", _hoisted_7, " "))
                          ]),
                          _createElementVNode("div", {
                            class: "uf-stores__item-label uf-stores__item-label-hidden",
                            ref_for: true,
                            ref: el => _ctx.addPlaceRef(el, index)
                          }, _toDisplayString(item.place_true_names), 513)
                        ]),
                        _: 2
                      }, [
                        (_ctx.placeBounding[index])
                          ? {
                              name: "right-icon",
                              fn: _withCtx(() => [
                                (!_ctx.showCheckedList)
                                  ? (_openBlock(), _createBlock(_component_van_popover, {
                                      key: 0,
                                      show: item.showPopover,
                                      "onUpdate:show": ($event: any) => ((item.showPopover) = $event),
                                      placement: "bottom-end"
                                    }, {
                                      reference: _withCtx(() => [
                                        _createVNode(_component_van_icon, {
                                          name: "info",
                                          color: "#6A717B",
                                          size: "24"
                                        })
                                      ]),
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_8, _toDisplayString(item.place_true_names), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["show", "onUpdate:show"]))
                                  : _createCommentVNode("", true)
                              ]),
                              key: "0"
                            }
                          : undefined
                      ]), 1032, ["class", "onClick"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_ctx.multiple)
                ? (_openBlock(), _createBlock(_component_van_button, {
                    key: 0,
                    plain: "",
                    class: "btn",
                    square: "",
                    type: "primary",
                    onClick: _ctx.leftButtonClick
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("已选 " + _toDisplayString(_ctx.checked.length), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_van_button, {
                class: "btn",
                color: "#3d6eeb",
                square: "",
                type: "success",
                onClick: _ctx.confirm
              }, {
                default: _withCtx(() => [
                  _createTextVNode("确认 ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show", "onOpened"]),
    _createVNode(_component_van_popup, {
      show: _ctx.showCheckedList,
      "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showCheckedList) = $event)),
      position: "right",
      style: { height: '100%', width: '100%' },
      onOpened: _ctx.opened
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_van_nav_bar, {
            title: "已选客户机构",
            "left-text": "返回",
            "left-arrow": "",
            onClickLeft: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showCheckedList = false))
          }),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_van_cell_group, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.list, (item, index) => {
                  return _withDirectives((_openBlock(), _createBlock(_component_van_cell, {
                    class: "active",
                    clickable: "",
                    center: "",
                    key: item.id
                  }, _createSlots({
                    icon: _withCtx(() => [
                      _createVNode(_component_van_checkbox, {
                        modelValue: _ctx.showCheckedList,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showCheckedList) = $event)),
                        style: {"margin-right":"10px"}
                      }, null, 8, ["modelValue"])
                    ]),
                    title: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, _toDisplayString(item.stores_name), 1)
                    ]),
                    label: _withCtx(() => [
                      _createElementVNode("div", _hoisted_14, [
                        (item.place_true_names)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(item.place_true_names), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock("i", _hoisted_15, " "))
                      ]),
                      _createElementVNode("div", {
                        class: "uf-stores__item-label uf-stores__item-label-hidden",
                        ref_for: true,
                        ref: el => _ctx.addCheckedPlaceRef(el, index)
                      }, _toDisplayString(item.place_true_names), 513)
                    ]),
                    _: 2
                  }, [
                    (_ctx.checkedPlacePopover[index])
                      ? {
                          name: "right-icon",
                          fn: _withCtx(() => [
                            _createVNode(_component_van_popover, {
                              show: item.showPopover,
                              "onUpdate:show": ($event: any) => ((item.showPopover) = $event),
                              placement: "bottom-end"
                            }, {
                              reference: _withCtx(() => [
                                _createVNode(_component_van_icon, {
                                  name: "info",
                                  color: "#3d6eeb",
                                  size: "24"
                                })
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_16, _toDisplayString(item.place_true_names), 1)
                              ]),
                              _: 2
                            }, 1032, ["show", "onUpdate:show"])
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1024)), [
                    [_vShow, _ctx.checked.includes(item)]
                  ])
                }), 128))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_van_button, {
                plain: "",
                class: "btn",
                square: "",
                type: "primary",
                onClick: _ctx.clear
              }, {
                default: _withCtx(() => [
                  _createTextVNode("清空 ")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_van_button, {
                class: "btn",
                color: "#3d6eeb",
                square: "",
                type: "success",
                onClick: _ctx.checkedListConfirm
              }, {
                default: _withCtx(() => [
                  _createTextVNode("确认 ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show", "onOpened"])
  ]))
}